<template>
    <div style="min-height: 100vh">
        <navbar active_screen="inbox" />
        <template v-if="ine(inboxes)">
            <v-infinite-scroll :loading="getting_data" @bottom="nextPage" style="overflow-y: scroll; overflow-x: hidden">
                <div class="br-12 content" v-for="(inbox, inbox_index) in inboxes" :key="inbox_index" @click="r('/inbox-detail', { inbox_id: inbox.id })">
                    <div class="row">
                        <!-- <div :class="$device != 'mobile' ? 'col-3' : 'col-5'">
                            <template v-if="$device == 'mobile'">
                                <div :class="'img-cropper is-' + $device">
                                    <img :src="inbox.image" />
                                </div>
                            </template>
                            <template v-else>
                                <img :src="inbox.image" style="width: 100%" />
                            </template>
                        </div>
                        <div :class="$device != 'mobile' ? 'col-9' : 'col-7'" style="justify-content: space-between; display: flex" :style="{ width: $device != 'mobile' ? '100%' : '60vw' }">
                            <div style="justify-content: space-between; display: flex">
                                <label class="fs-18 description">
                                    {{ inbox.title }}
                                </label>
                            </div>
                        </div> -->
                        <div class="col-6">
                            <img :src="inbox.image" style="width: 100%; border-top-left-radius: 12px; border-bottom-left-radius: 12px" />
                        </div>
                        <div class="col-6 p-16">
                            <span class="fs-18 fw-600 description">
                                {{ inbox.title }}
                            </span>
                        </div>
                    </div>
                </div>
            </v-infinite-scroll>
        </template>
        <div v-else class="text-center" style="display: flex; height: 100vh; justify-content: center; padding-bottom: 120px">
            <div style="margin: auto 0; position: relative; padding: 16px; border-radius: 1rem">
                <label class="data-not-found-label"> ยังไม่มีรายการ Inbox ในขณะนี้ </label>
            </div>
        </div>
        <div class="กำลังโหลดข้อมูลเพิ่ม" v-if="getting_data">กำลังโหลดข้อมูลเพิ่ม</div>
    </div>
</template>
<script>
import navbar from '../../components/navbar';
export default {
    components: {
        navbar,
    },
    data: function () {
        return {
            getting_data: true,
            current_page: 1,
            last_page: 0,
            inboxes: [],
        };
    },
    mounted() {
        // console.log('[src\\views\\inbox\\index.vue]');
        // console.log('$mode -->', this.$mode);
        // for (let i = 0; i < 18; i++) {
        //   this.inboxes.push({
        //     id: i + 1,
        //     image: 'https://via.placeholder.com/720x480.png?text=Sample',
        //     title:
        //       'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta.',
        //     description:
        //       'But I must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give you a complete account of the system, and expound the actual teachings of the great explorer of the truth, the master-builder of human happiness. No one rejects, dislikes, or avoids pleasure itself, because it is pleasure, but because those who do not know how to pursue pleasure rationally encounter consequences that are extremely painful. Nor again is there anyone who loves or pursues or desires to obtain pain of itself, because it is pain, but because occasionally circumstances occur in which toil and pain can procure him some great pleasure. To take a trivial example, which of us ever undertakes laborious physical exercise, except to obtain some advantage from it? But who has any right to find fault with a man who chooses to enjoy a pleasure that has no annoying consequences, or one who avoids a pain that produces no resultant pleasure? On the other hand, we denounc',
        //   });
        // }
        this._mounted();
    },
    methods: {
        nextPage() {
            if (this.current_page < this.last_page) {
                ++this.current_page;
                this.getInbox();
            }
        },
        _mounted: function () {
            this.getInbox(() => (this.getting_data = false));
        },
        getInbox: function (callback = null, current_page = null) {
            if (typeof current_page != 'number') current_page = this.current_page;
            this.$store.dispatch('user/POST', {
                payload: {
                    path: '/api/news/index',
                    data: {
                        page: current_page,
                        per_page: 20,
                    },
                    callback: (res) => {
                        if (res && res.data) {
                            this.last_page = res.last_page;
                            res.data.forEach((v) => {
                                var check_dup = this.inboxes.filter((v1) => v1.id == v.id);
                                if (check_dup.length == 0) {
                                    this.inboxes.push(v);
                                } else {
                                    this.inboxes = res.data;
                                }
                            });
                            console.log('this.inboxes', this.inboxes);
                            if (typeof callback == 'function') callback();
                        } else if (typeof callback == 'function') callback();
                    },
                },
            });
        },
        toggleFavorite(e, inbox) {
            event.stopPropagation();
            var url;
            if (!inbox.button_favorite) {
                url = '/api/favorite/delete';
            } else {
                url = '/api/favorite/add';
            }
            this.getting_data = true;
            this.$store.dispatch('user/POST', {
                payload: {
                    path: url,
                    data: {
                        xid: inbox.id,
                        type: 'news',
                    },
                    callback: (res) => {
                        console.log('res', res);
                        if (res && res.result == 'complete') {
                            this.getInbox();
                        } else {
                            const errors = {
                                message: '',
                            };
                            for (const [key, value] of Object.entries(res.errors)) {
                                if (key) {
                                    console.log('value[0]', value[0]);
                                    errors.message += value[0];
                                }
                            }
                            this.$confirm({
                                message: errors.message,
                                button: {
                                    yes: 'ปิดหน้าต่าง',
                                },
                                callback: (confirm) => {},
                            });
                            console.log('errors.message', errors.message);
                        }
                        this.getting_data = false;
                    },
                },
            });
        },
    },
};
</script>
<style scoped>
.content {
    margin: 16px 16px 0 16px;
    background-color: #ffffff;
}
/* .content.is-desktop,
.content.is-tablet {
    max-width: 1024px;
} */
.img-cropper {
    width: 25vw;
    height: 25vw;
    position: relative;
    overflow: hidden;
    border-radius: 50%;
    margin: 0 16px;
}
.img-cropper.is-desktop,
.img-cropper.is-tablet {
    width: 10vw;
    height: 10vw;
    margin: auto;
}
.img-cropper img {
    display: inline;
    height: 100%;
    width: auto;
    margin-left: -6vw;
}
.img-cropper.is-desktop img,
.img-cropper.is-tablet img {
    width: 100%;
    margin: 0;
}
.description {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    line-clamp: 3;
    -webkit-box-orient: vertical;
}
@media (max-device-width: 413px) {
    .img-cropper {
        margin: 0 8px;
    }
}
</style>